import * as React from "react"
import {formatPercentage} from "@ui-seeker/utils";
import ArrowBackground from "./ArrowBackground";


export default function ArrowPercentage({ value, prev, useBackground=false }) {

	let backgroundColor = 'transparent'
	if (useBackground && value >= 90)
		backgroundColor = 'success.light'
	else if (useBackground && value >= 80)
		backgroundColor = 'success.lighter'
	else if (useBackground && value >= 50)
		backgroundColor = 'error.lighter'
	else if (useBackground)
		backgroundColor = 'error.light'

	return <ArrowBackground value={value} prev={prev} backgroundColor={backgroundColor}>
		{formatPercentage(value)}
	</ArrowBackground>
}